import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { RadioLabel, Tag, Typography } from "@bookips/sds";
const MAX_BADGE_LENGTH = 8;
const CashProductItem = (param)=>{
    let { product , checked  } = param;
    const { bonusPointValue , bonusPointType , description , badge , price  } = product;
    return /*#__PURE__*/ _jsxs(RadioLabel, {
        value: String(product.id),
        classes: {
            root: cn("px-5 py-6 h-full hover:bg-gray-300/20", checked && "bg-indigo-0")
        },
        children: [
            description && /*#__PURE__*/ _jsx(Typography, {
                className: "text-secondary",
                variant: "body2",
                children: description
            }),
            /*#__PURE__*/ _jsxs(Typography, {
                className: "text-strong flex items-center gap-1.5",
                variant: "h6",
                children: [
                    price.toLocaleString(),
                    "원",
                    bonusPointValue && /*#__PURE__*/ _jsxs(Typography, {
                        className: "text-mint-400",
                        variant: "subtitle1",
                        as: "span",
                        children: [
                            "+",
                            bonusPointType === "PERCENT" ? "".concat(Math.floor(price * bonusPointValue / 100).toLocaleString(), "원") : "".concat(bonusPointValue.toLocaleString(), "원")
                        ]
                    }),
                    badge && /*#__PURE__*/ _jsx(Tag, {
                        bold: true,
                        size: "sm",
                        color: "red",
                        children: badge.length > MAX_BADGE_LENGTH ? badge.slice(0, MAX_BADGE_LENGTH) : badge
                    })
                ]
            })
        ]
    });
};
export default CashProductItem;
